<template>
    <div class="d-inline-block" @click.stop @keydown.stop>
        <button ref="trigger" type="button" class="au-icon-btn" :title="label" :aria-label="label" aria-haspopup="menu"
            :aria-expanded="open" @click="toggle">
            <i class="bi bi-three-dots"></i>
        </button>
        <Teleport to="body">
            <div v-if="open" class="au-menu" role="menu" :style="position" @click="close">
                <slot></slot>
            </div>
        </Teleport>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Menu jest przenoszone do <body> i pozycjonowane względem przycisku, żeby nie przycinał go kontener tabeli
export default defineComponent({
    name: "ActionMenu",
    props: {
        label: { type: String, required: true },
    },
    data() {
        return {
            open: false,
            position: {} as Record<string, string>,
        };
    },
    methods: {
        toggle() {
            if (this.open) {
                this.close();
            } else {
                this.show();
            }
        },
        show() {
            const rect = (this.$refs.trigger as HTMLElement).getBoundingClientRect();
            this.position = {
                top: `${rect.bottom + 6}px`,
                right: `${window.innerWidth - rect.right}px`,
            };
            // Zamyka inne otwarte menu - kliknięcie w ich przycisk nie dociera do dokumentu (stopPropagation)
            document.dispatchEvent(new CustomEvent("au-menu-open", { detail: this.$.uid }));
            this.open = true;
            document.addEventListener("au-menu-open", this.onOtherMenuOpen);
            document.addEventListener("click", this.close);
            document.addEventListener("keydown", this.onKeydown);
            window.addEventListener("scroll", this.close, true);
            window.addEventListener("resize", this.close);
        },
        close() {
            this.open = false;
            document.removeEventListener("au-menu-open", this.onOtherMenuOpen);
            document.removeEventListener("click", this.close);
            document.removeEventListener("keydown", this.onKeydown);
            window.removeEventListener("scroll", this.close, true);
            window.removeEventListener("resize", this.close);
        },
        onOtherMenuOpen(event: Event) {
            if ((event as CustomEvent<number>).detail !== this.$.uid) {
                this.close();
            }
        },
        onKeydown(event: KeyboardEvent) {
            if (event.key === "Escape") {
                this.close();
            }
        },
    },
    beforeUnmount() {
        this.close();
    },
});
</script>
